// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_INDEX_CATEGORY_DESCRIPTION_BABY = "Nejv\u011bt\u0161\u00ed v\u00fdb\u011br, kvalitn\u00ed d\u011btsk\u00fd bazar. Levn\u00e9 i kvalitn\u00ed. Jen od maminek.";
export const BAZAAR_INDEX_DESCRIPTION_BABY = "Kvalitn\u00ed d\u011btsk\u00fd bazar! Oble\u010den\u00ed pro d\u011bti, boty, ko\u010d\u00e1rky, hra\u010dky ... Levn\u00e9 i kvalitn\u00ed. Jen od maminek.";
export const BAZAAR_SEO_BABY = "Bazar";
export const BZ2_ADD_PRODUCT = "P\u0159idej inzer\u00e1t";
export const CONFIRM = "Potvr\u010f";
export const PAGE = "Strana";
